/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CreateApiCredentialsDto } from './createApiCredentialsDto';
import { CreateSmppCredentialsDto } from './createSmppCredentialsDto';
import { MTMOFilter } from './mTMOFilter';
import { ServerTypeEnum } from './serverTypeEnum';
import { SmsRouteOfSmppServer } from './smsRouteOfSmppServer';


export interface ServiceCompleteRequirementsDto { 
    serviceDetails?: MTMOFilter;
    smppContentRoute?: SmsRouteOfSmppServer;
    apiContentRoute?: SmsRouteOfSmppServer;
    smppContentRouteCredentials?: CreateSmppCredentialsDto;
    apiContentRouteCredentials?: CreateApiCredentialsDto;
    routeType: ServerTypeEnum;
}
